class Type {
	public static THREE_MONTH = new Type(3, "3 months");
	public static SIX_MONTHS = new Type(6, "6 months");
	public static ONE_YEAR = new Type(12, "1 year");
	public static TWO_YEARS = new Type(24, "2 years");

	private constructor(
		public readonly id: 3 | 6 | 12 | 24,
		public readonly label: string
	) {}

	public static get default(): Type {
		return this.TWO_YEARS;
	}

	public static values(): Type[] {
		return Object.values(Type);
	}

	public static getById(id?: number) {
		return this.values().find((value) => value.id === id);
	}

	public static getByIdOrDefault(id?: number): Type {
		return this.getById(id) || this.default;
	}
}

export { Type as LimitSoldResultsByMonthsType };
